import Divider from '@mui/material/Divider';

export { Divider };
